/**
 * NEXUS UI - Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Import global styles
import './styles/nexus-tokens.css';
import './styles/nexus-components.css';

// Add nexus-ui class to body
document.body.classList.add('nexus-ui');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
